export default {
  accordion: {
    panel: 'w-full',
    panelHeader: 'p-2',
    panelDetail: 'trans-500-max-h p-0',
    icon: 'float-right',
    expanded: 'md:max-h-500 border-b',
    collapsed: 'overflow-hidden p-0',
  },

  accordionStory: {
    panel: 'w-full py-20 border-b',
    panelHeader: 'panelHeader p-0 panelDetail',
    panelDetail: 'trans-500-max-h p-0',
    icon: 'float-right',
    expanded: 'md:max-h-500 pt-20',
    collapsed: 'overflow-hidden p-0',
    icon_span: 'icon_span',
  },
};
